import { Row } from "@/common/css";
import Icon from "@/common/ui/Image";
import { LightText2 } from "@/common/ui/Text";
import React from "react";

type STATUS = "PENDING" | "DECLINED" | "APPROVED";

interface ReviewStatusProps {
  status: STATUS;
}

const STATUS_ICON_MAP: Record<STATUS, { icon: string; color: string }> = {
  PENDING: {
    icon: "/icons/pending-icon.svg",
    color: "text-warning",
  },
  DECLINED: {
    icon: "/icons/declined-icon.svg",
    color: "text-text-error",
  },
  APPROVED: {
    icon: "/icons/verified.svg",
    color: "text-text-green",
  },
};

const ReviewStatus: React.FC<ReviewStatusProps> = ({ status }) => {
  const statusConfig = STATUS_ICON_MAP[status];

  return (
    <Row className="gap-x-2">
      <Icon src={statusConfig.icon} alt={`${status}-icon`} />
      <LightText2 text={status?.toLocaleLowerCase()} className={`${statusConfig.color} capitalize`} />
    </Row>
  );
};

export default ReviewStatus;
